function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_17015",
  "data-name": "Group 17015",
  transform: "translate(-3063.906 5204.521)"
}, React.createElement("path", {
  id: "Path_21982",
  "data-name": "Path 21982",
  d: "M3179-5187.072v5.351a1.352,1.352,0,0,0,.6,1.111l3.743,2.573a1.638,1.638,0,0,0,2.59-1.247v-10.229a1.638,1.638,0,0,0-2.59-1.247l-3.743,2.573A1.353,1.353,0,0,0,3179-5187.072Z",
  transform: "translate(-92.24 -10.792)"
}), React.createElement("path", {
  id: "Path_21983",
  "data-name": "Path 21983",
  d: "M3080.368-5204.522h-12.85a3.612,3.612,0,0,0-3.611,3.612v11.441a3.612,3.612,0,0,0,3.611,3.612h12.85a3.612,3.612,0,0,0,3.612-3.612v-11.441A3.612,3.612,0,0,0,3080.368-5204.522Zm-2.383,10.229-6.476,3.738a.952.952,0,0,1-1.428-.824v-7.477a.952.952,0,0,1,1.428-.826l6.476,3.739A.953.953,0,0,1,3077.985-5194.293Z",
  transform: "translate(0)"
}));

var SvgVideocalls = function SvgVideocalls(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29.785,
    height: 18.666,
    viewBox: "0 0 29.785 18.666",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVideocalls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Videocalls.8e560d10.svg";
export { ForwardRef as ReactComponent };